export default __webpack_public_path__ + "static/media/oslavy.fb66bb90.jpg";